import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import moment from 'moment';

import { Main, Filter } from 'Containers/';
import { TitledCard } from 'Components/';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { MEALS_PER_LABOR_HOUR_FORM_NAME } from 'Common/FormEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import {
  MealsPerLaborHourFieldEnum as Fields,
  ReportFieldEnum as ReportFields,
} from 'Common/FieldEnum';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';

import { MealsPerLaborHourForm } from './components/MealsPerLaborHourForm';

const now = moment().format(DATE_FORMAT_FOR_UI);

class MealsPerLaborHour extends Component {
  static path = '/mealsperlaborhour';

  get mainProps() {
    const { submit, reportFetching } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            loading: reportFetching,
            disabled: reportFetching,
            content: 'View',
            onClick: () => submit(MEALS_PER_LABOR_HOUR_FORM_NAME),
          },
        ],
        shown: true,
      },
    };
  }

  onSubmit = values => {
    const { getReport, getExcelFile } = this.props;

    if (values[ReportFields.ReportFormat] === reportFormatEnum.Excel) {
      getExcelFile(
        'reports/MealsPerLaborHourReport',
        'MealsPerLaborHours',
        values
      );
    } else {
      getReport('reports/MealsPerLaborHourReport', values);
    }
  };

  render() {
    return (
      <Fragment>
        <Filter title="Meals Per Labor Hour Report" />
        <Main {...this.mainProps}>
          <TitledCard title="Options">
            <MealsPerLaborHourForm
              initialValues={{
                [Fields.From]: now,
                [Fields.To]: now,
                [ReportFields.ReportFormat]: reportFormatEnum.PDF,
              }}
              onSubmit={this.onSubmit}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  submit,
};

MealsPerLaborHour = withReportSubscription(MealsPerLaborHour);

MealsPerLaborHour = connect(null, mapDispatchToProps)(MealsPerLaborHour);

export { MealsPerLaborHour };



// WEBPACK FOOTER //
// ./src/pages/mealsperlaborhour/MealsPerLaborHour.js